import React, { useState, useEffect, forwardRef } from 'react'
import { Text, Card, CardBody, CardHeader, Button, ArrowFirstIcon, AutoRenewIcon } from '@pancakeswap/uikit'
import { useSelector, useDispatch } from 'react-redux'
import { senderTokenConfig, senderTokenConfigChange, senderToken, vip } from '@/store'
import { useBalance, useSenderTokenAmount } from '@/hooks'
import { addressHand, approve, isMainAddress } from '@/utils'
import { SENDERTOKENCONTRACT } from '@/config'
import Notification from '@/components/Notification'
import { useWeb3React } from '@/hooks/useWeb3React'
import { SenderTokenItem } from '../style'
import { CardSwapper, CardItem } from './style'
import senderTokenAddressHandler from '@/utils/sender'

function App(props, ref) {
  // const senderBase = 200 // 每次发送200个地址
  const { upStep, senderBase } = props

  const [tokenConfig, setTokenConfig] = useState([])
  const dispatch = useDispatch()
  const config = useSelector(senderTokenConfig)
  const bnbAmount = useBalance()
  const serdenTokenAmount = useSenderTokenAmount()
  const tokenInfo = useSelector(senderToken)
  const { account, chainId, walletClient, provider } = useWeb3React()
  const [newConfig, setNewConfig] = useState([])
  const [totalAmount, setTotalAmount] = useState(0) // 发送代币总数量
  const [senderTotalNumber, setSenderTotalNumber] = useState(0) // 发送总次数
  const [isSender, setIsSender] = useState(false)


  useEffect(() => {
    if (config) {
      const configArr = []
      config.forEach((item) => {
        const _arr = item.split(/[,，]+/)
        configArr.push(_arr)
      })
      setTokenConfig(configArr)
      const _config = JSON.parse(JSON.stringify(config))
      setNewConfig(_config)
    }
  }, [config])
  const _vip = useSelector(vip)

  useEffect(() => {
    let total = 0
    tokenConfig.forEach((item) => {
      total += parseFloat(item[1])
    })
    const _totalNumber = Math.ceil(tokenConfig.length / senderBase)
    setSenderTotalNumber(_totalNumber)
    setTotalAmount(Number(total.toFixed(6)))
  }, [tokenConfig])

  const removeTokenHandler = (index: number) => {
    const _config = newConfig
    _config.splice(index, 1)
    dispatch(senderTokenConfigChange(_config))
  }

  const senderTokenHandler = async () => {
    if (!account) return Notification.Error("请先连接钱包")

    const tokens = tokenConfig.map(item => item[0])
    const amounts = tokenConfig.map(item => item[1])
    const isMain = isMainAddress(tokenInfo.address)

    setIsSender(true)

    try {
      if (!isMain) {
        await approve(
          account,
          tokenInfo.address,
          Math.ceil(totalAmount),
          SENDERTOKENCONTRACT[chainId],
          Number(tokenInfo.decimals),
          walletClient,
        )
      }

      await senderTokenAddressHandler({
        chainId,
        walletClient,
        publicClient:provider,
        tokenInfo: {
          address: tokenInfo.address,
          decimals: Number(tokenInfo.decimals),
        },
        tokens,
        amounts,
        senderBase,
        senderTotalNumber,
        isMainAddress: isMain,
        isVip: _vip,
      })
    } finally {
      setIsSender(false)
    }
  }


  return (
    <SenderTokenItem>
      <CardSwapper>
        <Text bold mb="8px">接受地址名单</Text>
        <Card isActive>
          <CardHeader className="CardItem">
            <div className="w7">Address</div>
            <div>Amount</div>
          </CardHeader>
          <CardBody>
            {tokenConfig.map((item, index) => (
              <div className="CardItem h40" key={index}>
                <div className="w7">{addressHand(item[0])}</div>
                <div className="flex1">
                  <div className="flexesb">
                    <span>{item[1]}</span>
                    <span onClick={() => removeTokenHandler(index)}>移除</span>
                  </div>
                </div>
              </div>
            ))}
          </CardBody>
        </Card>
      </CardSwapper>

      <CardSwapper>
        <Text bold mb="8px">摘要</Text>
        <Card>
          <CardItem>
            <CardBody className="item">
              <div>
                <Text bold fontSize="22px">
                  {tokenConfig.length}
                </Text>
                <Text fontSize="14px">地址总数</Text>
              </div>
            </CardBody>
            <CardBody className="item">
              <div>
                <Text bold fontSize="22px">
                  {totalAmount}
                </Text>
                <Text fontSize="14px">代币发送总数</Text>
              </div>
            </CardBody>
            <CardBody className="item">
              <div>
                <Text bold fontSize="22px">
                  {senderTotalNumber}
                </Text>
                <Text fontSize="14px">交易总数</Text>
              </div>
            </CardBody>
            <CardBody className="item">
              <div>
                <Text bold fontSize="22px">
                  {bnbAmount}
                </Text>
                <Text fontSize="14px">BNB余额</Text>
              </div>
            </CardBody>
            <CardBody className="item">
              <div>
                <Text bold fontSize="22px">
                  {serdenTokenAmount}
                </Text>
                <Text fontSize="14px">代币余额</Text>
              </div>
            </CardBody>
            <CardBody className="item">
              <div>
                <Text bold fontSize="22px">
                  0.038
                </Text>
                <Text fontSize="14px">预估手续费</Text>
              </div>
            </CardBody>
          </CardItem>
        </Card>
      </CardSwapper>

      <div className="flexcenter">
        <Button onClick={upStep}>
          <ArrowFirstIcon />
        </Button>
        {!isSender ? (
          <Button className="magrinl1" onClick={senderTokenHandler}>
            发送
          </Button>
        ) : (
          <Button isLoading endIcon={<AutoRenewIcon spin color="currentColor" />}>
            发送中
          </Button>
        )}
      </div>
    </SenderTokenItem>
  )
}

export default forwardRef(App)
